const assert = (statement: boolean, message: string) => {
  /* istanbul ignore next: (UI-5482) */
  if (!statement) {
    throw new Error(message);
  }
};

export default assert;
